import { render, staticRenderFns } from "./ViewGrantAddress.vue?vue&type=template&id=b5809154"
import script from "./ViewGrantAddress.vue?vue&type=script&lang=js"
export * from "./ViewGrantAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports